import { useState } from 'react';
import {
  Tab,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import customConfig from 'src/config';
import OutlookAddIn from './OutlookAddIn';
import GmailAddIn from './GmailAddIn';

enum AddInTab {
  Outlook = 0,
  Gmail = 1,
}

const AddInManagement = () => {
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const [activeTab, setActiveTab] = useState<AddInTab>(AddInTab.Outlook);
  const gmailAddInEnabled =
    customConfig.ui.featureToggle.gmailAddInConfigEnabled;

  return (
    <Tabs
      index={activeTab}
      onChange={(index: AddInTab) => setActiveTab(index)}
      display="flex"
      flexDirection="column"
      height="100%"
    >
      <TabList
        pt="12px"
        px="16px"
        borderBottom="1px solid"
        borderBottomColor={colorStyle.divider}
      >
        <Tab index={AddInTab.Outlook}>
          {t('administration.addInManagement.tab.outlook')}
        </Tab>
        {gmailAddInEnabled && (
          <Tab index={AddInTab.Gmail}>
            {t('administration.addInManagement.tab.gmail')}
          </Tab>
        )}
      </TabList>
      <TabPanels display="flex" flexDirection="column" flex={1} minHeight={0}>
        <TabPanel
          index={AddInTab.Outlook}
          display="flex"
          flexDirection="column"
          flex={1}
          minHeight={0}
        >
          {({ isSelected }: { isSelected: boolean }) =>
            isSelected && <OutlookAddIn />
          }
        </TabPanel>
        {gmailAddInEnabled && (
          <TabPanel
            index={AddInTab.Gmail}
            display="flex"
            flexDirection="column"
            flex={1}
            minHeight={0}
          >
            {({ isSelected }: { isSelected: boolean }) =>
              isSelected && <GmailAddIn />
            }
          </TabPanel>
        )}
      </TabPanels>
    </Tabs>
  );
};

export default AddInManagement;
